export const NAV_ITEMS = [
  { id: "home", label: "Αρχική", path: "/" },
  { id: "services", label: "Υπηρεσίες", path: "/services" },
  { id: "who-we-serve", label: "Σε Ποιους Απευθυνόμαστε", path: "/who-we-serve" },
  { id: "approach", label: "Μεθοδολογία", path: "/approach" },
  { id: "insights", label: "Άρθρα", path: "/insights" },
  { id: "contact", label: "Επικοινωνία", path: "/contact" },
];

export const ASSETS = {
  logo: "/assets/crestia-logo.png",
  mark: "/assets/crestia-mark.png",
  video: "/assets/crestia-hero-optimized-v1.mp4",
  videoWebm: "/assets/crestia-hero.webm",
  poster: "/assets/crestia-video-poster.jpg",
};

const U = (id, w = 1600) => `https://images.unsplash.com/${id}?auto=format&fit=crop&w=${w}&q=80`;

export const IMAGES = {
  hero: U("photo-1483094035713-218a81c0d971"),
  production: U("photo-1751888095242-fbb235e14581"),
  engineer: U("photo-1581091226825-a6a2a5aee158"),
  logistics: U("photo-1566449781267-88f21cc4af19"),
  port: U("photo-1494412574643-ff11b0a5c1c3"),
  cranes: U("photo-1578575437130-527eed3abbec"),
  bulk: U("photo-1691733137330-67a2ab7e42ea"),
  warehouse: U("photo-1586528116311-ad8dd3c8310d"),
  map: U("photo-1524661135-423995f22d0b"),
  technology: U("photo-1566476927456-446189d7b1ca"),
  commercial: U("photo-1546213290-e1b492ab3eee"),
  workspace: U("photo-1611269154421-4e27233ac5c7"),
  planning: U("photo-1553877522-43269d4ea984"),
};

/* Palette tokens used across the site */
export const PALETTE = {
  ivory: "#F8F6F0",
  champagne: "#F2EEE7",
  sand: "#E6DFD3",
  stone: "#D9D2C5",
  navy: "#0E1B31",
  navy2: "#16294A",
  slate: "#2C4A6F",
  bluegrey: "#8B9EB7",
  mist: "#EEF2F7",
  sage: "#5A7265",
  sageTint: "#EAF0EC",
  copper: "#C26D52",
  copperTint: "#F7EFE9",
  gold: "#C5A059",
  goldTint: "#F7F1E4",
  ink: "#3B4A5E",
  muted: "#6B7A8F",
};

export const TERMS = [
  "Αύξηση Πωλήσεων",
  "Στρατηγική Ανάπτυξης",
  "Οργάνωση Λειτουργίας",
  "Νέες Αγορές",
  "AI & Τεχνολογία",
  "Export Development",
  "KPIs",
  "Market Research",
  "Business Intelligence",
  "Εμπορικά Συστήματα",
  "CRM & Pipeline",
  "Go-to-Market",
];

export const HERO = {
  eyebrow: "Boutique Επιχειρηματική Συμβουλευτική",
  subtitle:
    "Η CRESTIA βοηθά επιχειρήσεις να αυξήσουν τις πωλήσεις τους, να οργανώσουν καλύτερα τη λειτουργία τους και να αξιοποιήσουν πρακτικά το AI, την τεχνολογία και τα επιχειρησιακά συστήματα.",
  closing: "Από τη στρατηγική μέχρι την εφαρμογή.",
};

export const OUTCOMES = [
  {
    icon: "trending",
    tone: "copper",
    title: "Αύξηση πωλήσεων",
    desc: "Οργανωμένη εμπορική λειτουργία που βρίσκει νέους πελάτες, ανοίγει νέες αγορές και δεν αφήνει ευκαιρίες να χάνονται.",
    span: "lg:col-span-7",
  },
  {
    icon: "layers",
    tone: "sage",
    title: "Καλύτερη οργάνωση",
    desc: "Ξεκάθαροι ρόλοι, διαδικασίες και συντονισμός στην καθημερινή λειτουργία.",
    span: "lg:col-span-5",
  },
  {
    icon: "workflow",
    tone: "slate",
    title: "Συστήματα & διαδικασίες",
    desc: "Workflows, reporting και KPIs που κάνουν την επιχείρηση πιο προβλέψιμη και λιγότερο εξαρτημένη από πρόσωπα.",
    span: "lg:col-span-4",
  },
  {
    icon: "brain",
    tone: "navy",
    title: "Πρακτική αξιοποίηση AI",
    desc: "AI και τεχνολογία εκεί όπου εξοικονομούν χρόνο, βελτιώνουν την πληροφόρηση και επιταχύνουν αποφάσεις.",
    span: "lg:col-span-4",
  },
  {
    icon: "target",
    tone: "gold",
    title: "Εμπορική ανάπτυξη",
    desc: "Sales pipeline, follow-up και CRM που μετατρέπουν τις ευκαιρίες σε πωλήσεις.",
    span: "lg:col-span-4",
  },
];

export const CYCLE = [
  {
    step: "01",
    title: "Ανάλυση",
    tone: "copper",
    desc: "Κατανοούμε σε βάθος την επιχείρηση: πωλήσεις, διαδικασίες, οργάνωση, ομάδα και αγορά.",
    does: "Συνεντεύξεις με τη διοίκηση και την ομάδα, ανάλυση δεδομένων πωλήσεων και λειτουργίας, χαρτογράφηση διαδικασιών και μελέτη της αγοράς και του ανταγωνισμού.",
    creates: ["Χάρτης τρέχουσας κατάστασης", "Ανάλυση αγοράς & ανταγωνισμού", "Λίστα προβλημάτων και ευκαιριών κατά προτεραιότητα"],
    receives: ["Διαγνωστική αποτύπωση της επιχείρησης", "Ξεκάθαρη εικόνα του πού χάνεται αξία", "Κοινή βάση για τις επόμενες αποφάσεις"],
    next: "Η διάγνωση καθορίζει ποιες προτεραιότητες αξίζει να μπουν στη στρατηγική — και ποιες όχι.",
  },
  {
    step: "02",
    title: "Στρατηγική",
    tone: "slate",
    desc: "Οργανώνουμε προτεραιότητες και σχεδιάζουμε ρεαλιστικό πλάνο ανάπτυξης με ορίζοντα και στόχους.",
    does: "Ορίζουμε κατεύθυνση, positioning, αγορές-στόχους και επιχειρηματικό μοντέλο. Μεταφράζουμε τη φιλοδοξία σε συγκεκριμένους στόχους και επιλογές.",
    creates: ["Στρατηγική κατεύθυνση & positioning", "Χάρτης πορείας ανάπτυξης", "Εμπορική και Go-to-Market στρατηγική"],
    receives: ["Ένα πλάνο που χωράει στους πόρους σας", "Σαφείς προτεραιότητες για 12–24 μήνες", "Κριτήρια επιτυχίας για κάθε άξονα"],
    next: "Η στρατηγική δίνει το «τι» — ο σχεδιασμός μετατρέπει κάθε επιλογή σε συστήματα και ρόλους.",
  },
  {
    step: "03",
    title: "Σχεδιασμός",
    tone: "sage",
    desc: "Σχεδιάζουμε τα συστήματα, τις διαδικασίες και τους δείκτες που θα στηρίξουν το πλάνο στην πράξη.",
    does: "Σχεδιάζουμε workflows, δομές CRM και reporting, πλαίσια KPIs και οργάνωση ρόλων. Επιλέγουμε εργαλεία — AI, BI, αυτοματοποίηση — με βάση την πραγματική ανάγκη.",
    creates: ["Σχέδια διαδικασιών & workflows", "Πλαίσιο KPIs και dashboards", "Οργανόγραμμα ρόλων και ευθυνών"],
    receives: ["Λειτουργικό σχέδιο υλοποίησης", "Προδιαγραφές συστημάτων και εργαλείων", "Χρονοδιάγραμμα με υπευθύνους"],
    next: "Ό,τι σχεδιάστηκε στο χαρτί περνάει στην καθημερινή λειτουργία της ομάδας σας.",
  },
  {
    step: "04",
    title: "Εφαρμογή",
    tone: "navy",
    desc: "Δεν σταματάμε στη συμβουλή. Δουλεύουμε μαζί με την ομάδα σας στην υλοποίηση, βήμα-βήμα.",
    does: "Συντονίζουμε την υλοποίηση, εκπαιδεύουμε την ομάδα, ενσωματώνουμε CRM, AI και BI εργαλεία στις διαδικασίες και λύνουμε ό,τι εμφανίζεται στην πράξη.",
    creates: ["Υλοποίηση πλάνου δράσης", "Ενσωμάτωση εργαλείων στη λειτουργία", "Ρουτίνες συντονισμού και follow-up"],
    receives: ["Διαδικασίες που χρησιμοποιούνται πραγματικά", "Ομάδα που ξέρει τι, πότε και πώς", "Ορατή πρόοδος από τις πρώτες εβδομάδες"],
    next: "Η εφαρμογή παράγει δεδομένα — και τα δεδομένα δείχνουν τι δουλεύει.",
  },
  {
    step: "05",
    title: "Μέτρηση",
    tone: "bluegrey",
    desc: "Παρακολουθούμε την πραγματική απόδοση με δεδομένα, όχι με εντυπώσεις.",
    does: "Παρακολουθούμε τους KPIs που ορίστηκαν, συγκρίνουμε με τους στόχους, εντοπίζουμε αποκλίσεις και τις αιτίες τους.",
    creates: ["Dashboards απόδοσης", "Δομημένες αναφορές ανά περίοδο", "Ανάλυση αποκλίσεων"],
    receives: ["Ενιαία εικόνα της απόδοσης", "Δεδομένα για αποφάσεις, όχι εκτιμήσεις", "Έγκαιρη ένδειξη όταν κάτι ξεφεύγει"],
    next: "Η μέτρηση τροφοδοτεί τη βελτίωση: τι ενισχύουμε, τι διορθώνουμε, τι σταματάμε.",
  },
  {
    step: "06",
    title: "Βελτίωση",
    tone: "gold",
    desc: "Προσαρμόζουμε, βελτιστοποιούμε και σχεδιάζουμε τον επόμενο κύκλο ανάπτυξης.",
    does: "Αξιολογούμε αποτελέσματα, βελτιστοποιούμε διαδικασίες και εργαλεία, και ορίζουμε τις προτεραιότητες του επόμενου κύκλου.",
    creates: ["Αξιολόγηση αποτελεσμάτων", "Βελτιωμένες διαδικασίες", "Πλάνο επόμενου κύκλου"],
    receives: ["Μια επιχείρηση που μαθαίνει από τα δεδομένα της", "Συνεχής — όχι εφάπαξ — βελτίωση", "Επόμενο στάδιο ανάπτυξης με σαφή βάση"],
    next: "Ο κύκλος ξαναρχίζει από την ανάλυση — με πιο ώριμη επιχείρηση και μεγαλύτερη φιλοδοξία.",
  },
];

export const TONES = {
  copper: { accent: "#C26D52", tint: "#F7EFE9", soft: "#F0D9CF", text: "#A3563E" },
  slate: { accent: "#2C4A6F", tint: "#EEF2F7", soft: "#D6E0EC", text: "#2C4A6F" },
  sage: { accent: "#5A7265", tint: "#EAF0EC", soft: "#CFDCD3", text: "#4A5F54" },
  navy: { accent: "#0E1B31", tint: "#E9ECF1", soft: "#CBD2DD", text: "#0E1B31" },
  bluegrey: { accent: "#6F86A3", tint: "#EEF2F7", soft: "#D9E1EB", text: "#4F6580" },
  gold: { accent: "#C5A059", tint: "#F7F1E4", soft: "#EBDDBB", text: "#8E7135" },
};

export const SERVICES = [
  {
    id: "strategy",
    num: "01",
    icon: "compass",
    tone: "copper",
    image: "planning",
    title: "Στρατηγική & Επιχειρηματική Ανάπτυξη",
    tagline: "Ξεκάθαρη κατεύθυνση και πλάνο ανάπτυξης που υλοποιείται.",
    desc: "Ορίζουμε πού πάει η επιχείρηση, ποιες αγορές στοχεύει και με ποιο μοντέλο — και το μετατρέπουμε σε χάρτη πορείας με δείκτες και πλάνο δράσης.",
    value: "Μια επιχείρηση με ξεκάθαρη στρατηγική επιλέγει καλύτερα πού να επενδύσει χρόνο και χρήμα, λέει «όχι» σε ευκαιρίες που την αποσπούν και κινείται με ρυθμό — γιατί όλοι ξέρουν προς τα πού.",
    signals: ["Η ανάπτυξη έχει «κολλήσει» χωρίς προφανή λόγο", "Υπάρχουν πολλές ιδέες, αλλά όχι σειρά προτεραιότητας", "Το πλάνο υπάρχει στο κεφάλι ενός ατόμου"],
    receives: ["Στρατηγικός χάρτης πορείας 12–24 μηνών", "Πλάνο δράσης με υπευθύνους και χρονισμό", "Σύστημα KPIs για την παρακολούθηση"],
    note: "Κάθε στρατηγική ολοκληρώνεται με συγκεκριμένο πλάνο δράσης και δείκτες παρακολούθησης — όχι με γενικές κατευθύνσεις.",
    clusters: [
      { name: "Κατεύθυνση", items: ["Επιχειρηματική Στρατηγική", "Στρατηγική Ανάπτυξης", "Στρατηγικός Σχεδιασμός", "Ανάπτυξη Επιχειρηματικού Μοντέλου", "Positioning"] },
      { name: "Αγορά & Εμπορικό", items: ["Εμπορική Στρατηγική", "Go-to-Market", "Ανάλυση Αγοράς", "Ανάλυση Ανταγωνισμού", "Ανάπτυξη Πωλήσεων", "Business Development"] },
      { name: "Εφαρμογή & Παρακολούθηση", items: ["Growth Roadmaps", "KPIs", "Πλάνα Δράσης", "Παρακολούθηση Απόδοσης"] },
    ],
  },
  {
    id: "exports",
    num: "02",
    icon: "globe",
    tone: "slate",
    image: "port",
    title: "Διεθνής Ανάπτυξη & Εξαγωγές",
    tagline: "Οργανωμένη είσοδος και ανάπτυξη σε νέες αγορές του εξωτερικού.",
    desc: "Από την επιλογή των σωστών χωρών έως τον εντοπισμό buyers και distributors, χτίζουμε μαζί σας ένα πρακτικό πλάνο εξαγωγικής ανάπτυξης.",
    value: "Οι εξαγωγές που πετυχαίνουν δεν ξεκινούν από μια έκθεση ή ένα τυχαίο email. Ξεκινούν από τη σωστή αγορά, τη σωστή τιμή, τους σωστούς συνεργάτες — και ένα πλάνο που κρατά τον ρυθμό μετά την πρώτη επαφή.",
    signals: ["Υπάρχει προϊόν με δυναμική, αλλά όχι διεθνές πλάνο", "Έγιναν προσπάθειες εξαγωγών χωρίς συνέχεια", "Δεν είναι σαφές ποια χώρα αξίζει πρώτη"],
    receives: ["Ιεράρχηση αγορών-στόχων με κριτήρια", "Λίστες buyers, importers και distributors", "Χάρτης εξαγωγικής ανάπτυξης με στάδια"],
    note: "Η εξαγωγική ανάπτυξη αντιμετωπίζεται ως συστηματική διαδικασία: από την έρευνα αγοράς έως τον πρώτο distributor.",
    clusters: [
      { name: "Στρατηγική & Ετοιμότητα", items: ["Στρατηγική Εξαγωγών", "Αξιολόγηση Εξαγωγικής Ετοιμότητας", "Στρατηγική Εισόδου σε Αγορές", "Χάρτες Εξαγωγικής Ανάπτυξης"] },
      { name: "Έρευνα & Επιλογή Αγορών", items: ["Διεθνής Έρευνα Αγοράς", "Επιλογή Αγορών & Χωρών", "Ιεράρχηση Χωρών-Στόχων", "Διεθνής Ανάλυση Τιμολόγησης", "Ανάλυση Ανταγωνισμού"] },
      { name: "Buyers, Distributors & Δίκτυο", items: ["Εντοπισμός Buyers & Importers", "Εντοπισμός Distributors", "Έρευνα Χονδρεμπόρων & Λιανεμπόρων", "Ευκαιρίες Private Label", "B2B Prospecting", "Lead Generation", "Ανάπτυξη Δικτύου Διανομής", "Ανάπτυξη Συνεργατών", "International Business Development", "Ανάπτυξη Εξαγωγικών Πωλήσεων"] },
    ],
  },
  {
    id: "transformation",
    num: "03",
    icon: "cog",
    tone: "sage",
    image: "production",
    title: "Επιχειρηματικός Μετασχηματισμός & Βελτίωση Λειτουργιών",
    tagline: "Λειτουργία και διαδικασίες που στηρίζουν — δεν φρενάρουν — την ανάπτυξη.",
    desc: "Αναλύουμε και ανασχεδιάζουμε τον τρόπο που δουλεύει η επιχείρηση: διαδικασίες, ρόλοι, συντονισμός και συστήματα που κλιμακώνονται.",
    value: "Όταν η λειτουργία είναι οργανωμένη, η ανάπτυξη δεν φέρνει χάος. Η ομάδα ξέρει τι κάνει, οι πληροφορίες ρέουν και η διοίκηση σταματά να σβήνει φωτιές — και αρχίζει να διοικεί.",
    signals: ["Οι ίδιες καθυστερήσεις επαναλαμβάνονται", "Όλα περνούν από τον ιδιοκτήτη", "Νέοι άνθρωποι αργούν να γίνουν παραγωγικοί"],
    receives: ["Ανασχεδιασμένες διαδικασίες και workflows", "Ξεκάθαρους ρόλους και σημεία συντονισμού", "Dashboards και δομές reporting"],
    note: "Ο μετασχηματισμός σχεδιάζεται ώστε οι νέες διαδικασίες να υιοθετούνται από την ομάδα — όχι να μένουν στο χαρτί.",
    clusters: [
      { name: "Διαδικασίες", items: ["Ανάλυση Επιχειρηματικών Διαδικασιών", "Βελτιστοποίηση Διαδικασιών", "Σχεδιασμός Workflows", "Κλιμακούμενες Διαδικασίες", "Ανασχεδιασμός Εμπορικών Διαδικασιών", "Διαδικασίες Πωλήσεων"] },
      { name: "Οργάνωση", items: ["Λειτουργική Βελτίωση", "Οργανωτική Βελτίωση", "Εσωτερικός Συντονισμός", "Βελτίωση Παραγωγικότητας", "Επιχειρησιακός Σχεδιασμός", "Υλοποίηση Αλλαγών"] },
      { name: "Μέτρηση & Αποφάσεις", items: ["Πλαίσια KPIs", "Dashboards", "Δομές Reporting", "Συστήματα Λήψης Αποφάσεων"] },
    ],
  },
  {
    id: "ai-digital",
    num: "04",
    icon: "brain",
    tone: "navy",
    image: "technology",
    title: "AI & Digital Enablement",
    tagline: "AI και τεχνολογία με πρακτικό όφελος — όχι buzzwords.",
    desc: "Εντοπίζουμε πού το AI και η αυτοματοποίηση γλιτώνουν πραγματικό χρόνο στη δική σας επιχείρηση και τα ενσωματώνουμε στις καθημερινές διαδικασίες.",
    value: "Το AI αξίζει όταν αφαιρεί επαναλαμβανόμενη δουλειά, βελτιώνει την πληροφόρηση και βοηθά την ομάδα να αποφασίζει ταχύτερα. Ξεκινάμε από τη διαδικασία — όχι από το εργαλείο.",
    signals: ["Ώρες χάνονται σε χειροκίνητες, επαναλαμβανόμενες εργασίες", "Υπάρχουν δεδομένα, αλλά όχι εικόνα", "Έγιναν δοκιμές με AI που δεν έμειναν"],
    receives: ["Χάρτη εφαρμογών AI με προτεραιότητες", "Αυτοματοποιημένα workflows σε λειτουργία", "Πλάνο υλοποίησης και εκπαίδευση ομάδας"],
    note: "Η αξία μετριέται σε χρόνο που εξοικονομείται, καλύτερη πληροφόρηση και ταχύτερες αποφάσεις — όχι σε εντυπωσιακά εργαλεία.",
    clusters: [
      { name: "Εντοπισμός & Πλάνο", items: ["Εντοπισμός Εφαρμογών AI", "Αξιολόγηση Ευκαιριών AI", "Πλάνο Υλοποίησης AI", "Χάρτης Ψηφιακού Μετασχηματισμού"] },
      { name: "Αυτοματοποίηση", items: ["Workflows με Υποστήριξη AI", "Αυτοματοποίηση Διαδικασιών", "Αυτοματοποίηση Επαναλαμβανόμενων Εργασιών", "Επανασχεδιασμός Ψηφιακών Διαδικασιών"] },
      { name: "AI στη Λειτουργία", items: ["AI για Έρευνα", "AI για Πωλήσεις", "AI για Business Development", "AI για Εσωτερικές Λειτουργίες", "Υποστήριξη Αποφάσεων με AI", "Business Intelligence", "Εργαλεία Διοίκησης με Δεδομένα"] },
    ],
  },
  {
    id: "bi-market",
    num: "05",
    icon: "chart",
    tone: "bluegrey",
    image: "workspace",
    title: "Market & Business Intelligence",
    tagline: "Αποφάσεις με βάση δεδομένα, όχι εκτιμήσεις.",
    desc: "Μετατρέπουμε την έρευνα αγοράς, τον ανταγωνισμό και τα εσωτερικά σας δεδομένα σε χρήσιμη γνώση για κάθε επιχειρηματική απόφαση.",
    value: "Η καλή πληροφόρηση αλλάζει το επίπεδο των αποφάσεων: ποια αγορά, ποια τιμή, ποιος πελάτης, ποιος ανταγωνιστής. Και όταν η γνώση καταλήγει σε dashboard, γίνεται καθημερινό εργαλείο.",
    signals: ["Οι αποφάσεις βασίζονται σε εντύπωση και εμπειρία", "Δεν υπάρχει ενιαία εικόνα πωλήσεων και αγοράς", "Οι τιμές ορίζονται χωρίς σύγκριση με τον ανταγωνισμό"],
    receives: ["Έρευνες αγοράς και ανταγωνισμού με συμπεράσματα", "Dashboards με τους δείκτες που μετρούν", "Χαρτογράφηση ευκαιριών κατά προτεραιότητα"],
    note: "Η γνώση καταλήγει σε dashboards και δείκτες που τροφοδοτούν τις καθημερινές αποφάσεις — όχι σε reports που ξεχνιούνται.",
    clusters: [
      { name: "Αγορά", items: ["Market Research", "Εκτίμηση Μεγέθους Αγοράς", "Ανάλυση Κλάδου", "Ανάλυση Χώρας", "Ανάλυση Ελκυστικότητας Αγοράς", "Ανάλυση Τάσεων"] },
      { name: "Ανταγωνισμός & Τιμές", items: ["Έρευνα Ανταγωνισμού", "Ανταγωνιστικό Benchmarking", "Έρευνα Τιμολόγησης"] },
      { name: "Πελάτες & Ευκαιρίες", items: ["Έρευνα Πελατών & Buyers", "Εμπορική Πληροφόρηση", "Χαρτογράφηση Ευκαιριών", "Έρευνα Συνεργατών", "Έρευνα Υποστήριξης Αποφάσεων"] },
    ],
  },
  {
    id: "commercial",
    num: "06",
    icon: "target",
    tone: "gold",
    image: "commercial",
    title: "Commercial & Business Development Support",
    tagline: "Εμπορική λειτουργία που βρίσκει πελάτες και κλείνει πωλήσεις συστηματικά.",
    desc: "Οργανώνουμε όλο τον εμπορικό κύκλο: από τον εντοπισμό των σωστών πελατών-στόχων και το sales pipeline έως το follow-up και την παρακολούθηση της απόδοσης.",
    value: "Μια εμπορική μηχανή που δουλεύει επαναλήψιμα δεν εξαρτάται από την τύχη ή από έναν καλό πωλητή. Έχει στόχευση, ρυθμό, follow-up και δείκτες — και παράγει πωλήσεις κάθε μήνα.",
    signals: ["Οι πωλήσεις έρχονται από συστάσεις, όχι από σύστημα", "Ευκαιρίες χάνονται από έλλειψη follow-up", "Το CRM υπάρχει αλλά δεν χρησιμοποιείται"],
    receives: ["Λίστες πελατών-στόχων και τμηματοποίηση", "Sales pipeline με στάδια και ρουτίνες follow-up", "Δομή CRM και δείκτες εμπορικής απόδοσης"],
    note: "Ο στόχος είναι μια εμπορική μηχανή που δουλεύει επαναλήψιμα — όχι πωλήσεις που εξαρτώνται από την τύχη ή από ένα άτομο.",
    clusters: [
      { name: "Στόχευση", items: ["Στρατηγική Business Development", "Εντοπισμός Αγορών-Στόχων", "Εντοπισμός Λογαριασμών-Στόχων", "Τμηματοποίηση Πελατών", "Χαρτογράφηση Εμπορικών Ευκαιριών"] },
      { name: "Pipeline & Prospecting", items: ["B2B Prospecting", "Δημιουργία Υποψήφιων Πελατών", "Ανάπτυξη Sales Pipeline", "Δομές CRM", "Διαδικασίες Follow-Up"] },
      { name: "Δίκτυο & Απόδοση", items: ["Ανάπτυξη Συνεργατών", "Ανάπτυξη Δικτύου Διανομής", "Εμπορικός Σχεδιασμός", "Παρακολούθηση Εμπορικής Απόδοσης", "Επαναλήψιμες Εμπορικές Διαδικασίες"] },
    ],
  },
].map((s) => ({ ...s, capabilities: s.clusters.flatMap((c) => c.items) }));

export const PROFILES = [
  {
    id: "small",
    icon: "store",
    tone: "copper",
    image: "commercial",
    title: "Ατομικές & Μικρές Επιχειρήσεις",
    short: "Ατομικές & Μικρές",
    tagline: "Περισσότερες πωλήσεις. Καλύτερη οργάνωση. Πιο δυνατή επιχείρηση.",
    intro: "Επιχειρήσεις όπου ο ιδιοκτήτης είναι ταυτόχρονα πωλητής, διευθυντής και παραγωγή. Η ανάπτυξη εξαρτάται από τον χρόνο ενός ατόμου — και ο χρόνος τελειώνει.",
    challenges: ["Οι πωλήσεις έρχονται άτακτα, από γνωριμίες και συστάσεις", "Δεν υπάρχει χρόνος για οργάνωση — όλα γίνονται «στο πόδι»", "Τα εργαλεία (CRM, AI) φαίνονται πολυπλοκότητα, όχι βοήθεια", "Δύσκολη απόφαση: τι να πρωτοβελτιώσω;"],
    improves: ["Εμπορική οργάνωση: ποιους στοχεύω, πώς, πότε", "Καθημερινή λειτουργία με απλές, σταθερές ρουτίνες", "Ξεκάθαρες διαδικασίες που δεν εξαρτώνται από τη μνήμη", "Αξιοποίηση χρόνου και εργαλείων χωρίς υπερβολές"],
    areas: ["Απλό σύστημα πωλήσεων & follow-up", "Οργάνωση λειτουργίας σε 3–5 βασικές διαδικασίες", "Πρακτικά εργαλεία AI για επαναλαμβανόμενη δουλειά", "Πλάνο ανάπτυξης με σειρά προτεραιότητας"],
    outcomes: ["Περισσότεροι και πιο σταθεροί πελάτες", "Λιγότερο χάος, περισσότερος έλεγχος", "Ανάπτυξη χωρίς περιττή πολυπλοκότητα"],
  },
  {
    id: "sme",
    icon: "factory",
    tone: "sage",
    image: "engineer",
    title: "Μικρομεσαίες & Παραγωγικές Επιχειρήσεις",
    short: "Μικρομεσαίες & Παραγωγικές",
    tagline: "Οργανώστε την ανάπτυξη πριν η ανάπτυξη γίνει πολυπλοκότητα.",
    intro: "Επιχειρήσεις που μεγάλωσαν και τώρα νιώθουν το βάρος: περισσότεροι άνθρωποι, περισσότερες παραγγελίες, περισσότερα σημεία που κάτι μπορεί να πάει λάθος.",
    challenges: ["Η ανάπτυξη έφερε συντονιστικά προβλήματα ανάμεσα σε τμήματα", "Οι διαδικασίες δεν κλιμακώνονται — λειτουργούν για 10, όχι για 40", "Η διοίκηση δεν έχει ενιαία εικόνα με δείκτες", "Η εμπορική λειτουργία μένει πίσω από την παραγωγική δυνατότητα"],
    improves: ["Οργάνωση και συντονισμός ανάμεσα σε τμήματα", "Διαδικασίες και workflows που αντέχουν την ανάπτυξη", "Εμπορική ανάπτυξη με σύστημα, όχι με ευκαιρίες", "KPIs και δομημένο reporting προς τη διοίκηση"],
    areas: ["Ανασχεδιασμός διαδικασιών & ρόλων", "Dashboards και ρουτίνες reporting", "Sales pipeline & CRM για B2B πελάτες", "Αυτοματοποίηση και AI σε λειτουργικές εργασίες"],
    outcomes: ["Λειτουργία που στηρίζει την ανάπτυξη", "Διοίκηση με δεδομένα, όχι με εντυπώσεις", "Εμπορικό τμήμα που φέρνει έργο σταθερά"],
  },
  {
    id: "export",
    icon: "globe",
    tone: "slate",
    image: "port",
    title: "Εμπορικές, Παραγωγικές & Εξαγωγικές Επιχειρήσεις",
    short: "Εμπορικές & Εξαγωγικές",
    tagline: "Από την εμπορική ευκαιρία σε οργανωμένη ανάπτυξη νέων αγορών.",
    intro: "Επιχειρήσεις με προϊόν που μπορεί να ταξιδέψει — και φιλοδοξία για νέες αγορές, στην Ελλάδα και στο εξωτερικό. Χρειάζονται μέθοδο, όχι τυχαίες επαφές.",
    challenges: ["Οι εξαγωγές ξεκίνησαν αντιδραστικά, από τυχαία ζήτηση", "Δεν είναι σαφές ποιες χώρες και ποια κανάλια αξίζουν", "Η εύρεση buyers και distributors γίνεται χωρίς σύστημα", "Η τιμολόγηση δεν έχει διεθνή σύγκριση"],
    improves: ["Ανάπτυξη πωλήσεων σε νέες αγορές με πλάνο", "Εντοπισμός buyers, distributors και partners με κριτήρια", "Export Development ως οργανωμένη διαδικασία", "Market Research πριν από κάθε σημαντική κίνηση"],
    areas: ["Ιεράρχηση αγορών-στόχων", "Λίστες και προσέγγιση buyers & distributors", "Εμπορική στρατηγική και τιμολόγηση ανά αγορά", "Δομή follow-up και διαχείρισης διεθνών leads"],
    outcomes: ["Είσοδος σε αγορές που αξίζουν", "Δίκτυο συνεργατών που χτίζεται συστηματικά", "Διεθνείς πωλήσεις με συνέχεια, όχι με σπασμωδικές κινήσεις"],
  },
];

export const SALES_POINTS = [
  { title: "Στόχευση", desc: "Εντοπισμός νέων πελατών και αγορών-στόχων με κριτήρια." },
  { title: "Pipeline", desc: "Οργάνωση του sales pipeline από την πρώτη επαφή έως το κλείσιμο." },
  { title: "Δίκτυο", desc: "Εύρεση buyers, distributors και συνεργατών σε Ελλάδα και εξωτερικό." },
  { title: "Follow-up", desc: "Διαδικασίες follow-up που δεν αφήνουν ευκαιρίες να χάνονται." },
  { title: "CRM & Δείκτες", desc: "Δομές CRM και παρακολούθηση εμπορικής απόδοσης." },
];

export const PIPELINE_STAGES = ["Στόχευση", "Προσέγγιση", "Συζήτηση", "Πρόταση", "Κλείσιμο", "Follow-up"];
